// extracted by mini-css-extract-plugin
module.exports = {"castCrewComponentWrapper":"hv","castCrewHeader":"hw","castCrewBody":"hx","castCrewTitle":"hy","slipnslideArrow":"hz"};